var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g66, _path27, _path28, _path29, _path30, _path31, _path32, _g67, _g68, _path33, _path34, _path35, _path36, _path37, _g69;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassportPhase2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1003.25 1076.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-Passport-p2 {\n        stroke: #1071e5;\n      }\n\n      .cls-1-Passport-p2, .cls-2-Passport-p2, .cls-3-Passport-p2 {\n        fill: #fff;\n      }\n\n      .cls-4-Passport-p2 {\n        fill: #6db1ff;\n      }\n\n      .cls-4-Passport-p2{\n        stroke: rgba(0, 0, 0, 0);\n      }\n\n      .cls-5-Passport-p2 {\n        fill: transparent;\n      }\n\n      .cls-6-Passport-p2, .cls-2-Passport-p2, .cls-7-Passport-p2, .cls-8-Passport-p2, .cls-9-Passport-p2, .cls-10-Passport-p2{\n        stroke-width: 0px;\n      }\n\n      .cls-11-Passport-p2 {\n        fill: url(#passport-linear-gradient-p2);\n      }\n\n      .cls-11-Passport-p2, .cls-12-Passport-p2, .cls-13-Passport-p2, .cls-3-Passport-p2, .cls-14-Passport-p2 {\n        stroke: #2b8eff;\n      }\n\n      .cls-12-Passport-p2 {\n        stroke-width: .05px;\n      }\n\n      .cls-12-Passport-p2, .cls-13-Passport-p2, .cls-7-Passport-p2 {\n        fill: #2b8eff;\n      }\n\n      .cls-8-Passport-p2 {\n        fill: #3a414a;\n      }\n\n      .cls-9-Passport-p2 {\n        fill: #e81313;\n      }\n\n      .cls-14-Passport-p2 {\n        fill: none;\n      }\n\n      .cls-10-Passport-p2{\n        fill: #008a0e;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "passport-linear-gradient-p2",
    x1: 331.12,
    y1: 1423.6,
    x2: 331.12,
    y2: 1217.98,
    gradientTransform: "translate(500.5 1901.62) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6db1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-Passport-p2",
    d: "M.5,6.5C.5,3.19,3.19.5,6.5.5h330.25c3.31,0,6,2.69,6,6v64.1c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6V6.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "cls-8-Passport-p2",
    d: "M82.51,36.82c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "cls-8-Passport-p2",
    d: "M103.01,32.13c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM102.94,43.27c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "cls-8-Passport-p2",
    d: "M119.58,32.13c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "cls-8-Passport-p2",
    d: "M133.09,45.1c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "cls-8-Passport-p2",
    d: "M145.93,42.05c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM142.87,37.36c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-2",
    "data-name": "ad",
    className: "cls-8-Passport-p2",
    d: "M156.11,32.13c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-2",
    "data-name": "ae",
    className: "cls-8-Passport-p2",
    d: "M169.62,45.1c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ab-2",
    "data-name": "ab",
    className: "cls-8-Passport-p2",
    d: "M181.23,36.82c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "cls-8-Passport-p2",
    d: "M202.01,34.65c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "cls-8-Passport-p2",
    d: "M218.17,43c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM214.91,43.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-3",
    "data-name": "ad",
    className: "cls-8-Passport-p2",
    d: "M231.89,32.13c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "cls-8-Passport-p2",
    d: "M250.83,44.9c.75,5.98-8.15,7.2-11.14,3.53-.27-.41-.41-.88-.54-1.43l3.33-.41c.2,1.09,1.09,1.63,2.31,1.7,2.72,0,2.85-2.51,2.72-5.36-.75,1.49-2.04,2.38-4.14,2.38-3.6,0-4.75-2.92-4.75-6.59s1.22-6.52,4.96-6.59c2.04,0,3.12.95,4.01,2.31l.14-2.04h3.19l-.07,12.49ZM244.72,42.93c2.17,0,2.78-1.83,2.78-4.28s-.61-4.21-2.72-4.21-2.65,1.97-2.72,4.28c0,2.44.61,4.21,2.65,4.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-2",
    "data-name": "af",
    className: "cls-8-Passport-p2",
    d: "M265.02,42.05c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM261.97,37.36c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-Passport-p2",
    d: "M660.5,6.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v64.1c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6V6.5Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "cls-8-Passport-p2",
    d: "M716.84,17.93v5.23h8.62v2.72h-8.62v6.18h-3.53V15.22h12.43v2.72h-8.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "cls-8-Passport-p2",
    d: "M732.32,32.33c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-4",
    "data-name": "ad",
    className: "cls-8-Passport-p2",
    d: "M750.59,18.88c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "cls-8-Passport-p2",
    d: "M769.19,27.78c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-3",
    "data-name": "ae",
    className: "cls-8-Passport-p2",
    d: "M777.68,31.85c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "cls-8-Passport-p2",
    d: "M779.65,16.85v-2.51h3.4v2.51h-3.4ZM779.65,32.06v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-2",
    "data-name": "ac",
    className: "cls-8-Passport-p2",
    d: "M792.21,18.88c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM792.14,30.02c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-5",
    "data-name": "ad",
    className: "cls-8-Passport-p2",
    d: "M808.78,18.88c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-2",
    "data-name": "ah",
    className: "cls-8-Passport-p2",
    d: "M823.51,29.75c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM820.25,29.95c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "cls-8-Passport-p2",
    d: "M829.76,32.06V14.33h3.4v17.72h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "cls-8-Passport-p2",
    d: "M835.12,32.53l3.46-18.2h2.85l-3.46,18.2h-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "cls-8-Passport-p2",
    d: "M850.88,17.93v14.12h-3.53v-14.12h-5.43v-2.72h14.4v2.72h-5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-3",
    "data-name": "af",
    className: "cls-8-Passport-p2",
    d: "M867.24,28.8c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM864.19,24.11c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-2",
    "data-name": "al",
    className: "cls-8-Passport-p2",
    d: "M881.16,27.78c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-2",
    "data-name": "ag",
    className: "cls-8-Passport-p2",
    d: "M889.58,21.4c-4.01,0-2.31,6.59-2.65,10.66h-3.4V14.33h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-6",
    "data-name": "ad",
    className: "cls-8-Passport-p2",
    d: "M905.88,18.88c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am-2",
    "data-name": "am",
    className: "cls-8-Passport-p2",
    d: "M913.28,16.85v-2.51h3.4v2.51h-3.4ZM913.28,32.06v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al-3",
    "data-name": "al",
    className: "cls-8-Passport-p2",
    d: "M931.27,27.78c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-3",
    "data-name": "ah",
    className: "cls-8-Passport-p2",
    d: "M940.98,29.75c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM937.72,29.95c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-2",
    "data-name": "an",
    className: "cls-8-Passport-p2",
    d: "M947.23,32.06V14.33h3.4v17.72h-3.4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ab-3",
    "data-name": "ab",
    className: "cls-8-Passport-p2",
    d: "M791.87,52.9c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-3",
    "data-name": "ag",
    className: "cls-8-Passport-p2",
    d: "M812.65,50.73c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-4",
    "data-name": "ah",
    className: "cls-8-Passport-p2",
    d: "M828.81,59.08c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM825.55,59.28c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-7",
    "data-name": "ad",
    className: "cls-8-Passport-p2",
    d: "M842.52,48.22c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-2",
    "data-name": "ai",
    className: "cls-8-Passport-p2",
    d: "M861.47,60.98c.75,5.98-8.15,7.2-11.14,3.53-.27-.41-.41-.88-.54-1.43l3.33-.41c.2,1.09,1.09,1.63,2.31,1.7,2.72,0,2.85-2.51,2.72-5.36-.75,1.49-2.04,2.38-4.14,2.38-3.6,0-4.75-2.92-4.75-6.59s1.22-6.52,4.96-6.59c2.04,0,3.12.95,4.01,2.31l.14-2.04h3.19l-.07,12.49ZM855.36,59.01c2.17,0,2.78-1.83,2.78-4.28s-.61-4.21-2.72-4.21-2.65,1.97-2.72,4.28c0,2.44.61,4.21,2.65,4.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-4",
    "data-name": "af",
    className: "cls-8-Passport-p2",
    d: "M875.66,58.13c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM872.6,53.44c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3-Passport-p2",
    d: "M.5,117.44c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "cls-6-Passport-p2",
    d: "M64.48,143.37v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "cls-6-Passport-p2",
    d: "M77.58,147.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "cls-6-Passport-p2",
    d: "M87.5,155.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM81.18,154.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "cls-6-Passport-p2",
    d: "M99.45,145.14c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "cls-6-Passport-p2",
    d: "M114.25,148.6c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "cls-6-Passport-p2",
    d: "M118.94,158.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-2",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M132.24,155.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM125.93,154.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "cls-6-Passport-p2",
    d: "M140.26,155.12c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "cls-6-Passport-p2",
    d: "M144.67,142.63v-2.04h2.17v2.04h-2.17ZM144.67,158.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "cls-6-Passport-p2",
    d: "M155.19,145.14c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM155.13,156.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-2",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M169.93,145.14c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-2",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M186.36,155.12c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az",
    className: "cls-6-Passport-p2",
    d: "M195.94,145.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM199.47,150.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA",
    className: "cls-6-Passport-p2",
    d: "M216.98,146.84c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB",
    className: "cls-6-Passport-p2",
    d: "M230.84,145.14c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM230.29,156.95c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-2",
    "data-name": "av",
    className: "cls-6-Passport-p2",
    d: "M238.24,158.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-3",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M251.55,155.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM245.23,154.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-3",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M259.56,155.12c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-2",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M269.13,145.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM272.66,150.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-2",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M285.09,148.6c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-2",
    "data-name": "aB",
    className: "cls-6-Passport-p2",
    d: "M62.48,174.47c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM61.93,186.29c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-2",
    "data-name": "ar",
    className: "cls-6-Passport-p2",
    d: "M75.99,176.58c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-2",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M83.12,174.47c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM83.05,186.29c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC",
    className: "cls-6-Passport-p2",
    d: "M97.24,187.65h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-2",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M103.76,171.96v-2.04h2.17v2.04h-2.17ZM103.76,187.65v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD",
    className: "cls-6-Passport-p2",
    d: "M113.27,174.47c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM113.88,176.1c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-3",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M127.86,174.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM131.4,179.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-2",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M140.43,174.47c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM141.04,176.1c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aE",
    className: "cls-6-Passport-p2",
    d: "M162.83,174.47c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM162.29,186.29c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF",
    className: "cls-6-Passport-p2",
    d: "M180.76,174.74l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aG",
    className: "cls-6-Passport-p2",
    d: "M189.86,187.65v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH",
    className: "cls-6-Passport-p2",
    d: "M205.27,178.75c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM198.69,178c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM198.69,185.81c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI",
    className: "cls-6-Passport-p2",
    d: "M226.46,181.33c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-4",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M239.09,184.45c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-4",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M248.66,174.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM252.19,179.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-4",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M265.02,185.2c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM258.71,184.05c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-2",
    "data-name": "aA",
    className: "cls-6-Passport-p2",
    d: "M283.29,176.17c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "rect5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3-Passport-p2",
    d: "M.5,288.05c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "e-2",
    "data-name": "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aq-2",
    "data-name": "aq",
    className: "cls-6-Passport-p2",
    d: "M22.45,328.92v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-3",
    "data-name": "ar",
    className: "cls-6-Passport-p2",
    d: "M35.55,332.79c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-5",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M45.47,341.41c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM39.15,340.26c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-3",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M57.42,330.68c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-3",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M72.22,334.15c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-3",
    "data-name": "av",
    className: "cls-6-Passport-p2",
    d: "M76.9,343.86v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-6",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M90.21,341.41c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM83.9,340.26c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-5",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M98.23,340.66c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-3",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M102.64,328.17v-2.04h2.17v2.04h-2.17ZM102.64,343.86v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-3",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M113.16,330.68c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM113.1,342.5c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-4",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M127.9,330.68c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ar-4",
    "data-name": "ar",
    className: "cls-6-Passport-p2",
    d: "M148.06,332.79c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-5",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M155.19,330.68c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM158.73,336.18c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-2",
    "data-name": "aC",
    className: "cls-6-Passport-p2",
    d: "M169.32,343.86h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-4",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M175.84,328.17v-2.04h2.17v2.04h-2.17ZM175.84,343.86v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-6",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M186.36,330.68c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM189.89,336.18c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ",
    className: "cls-6-Passport-p2",
    d: "M207.14,343.86h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-7",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M217.53,330.68c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM221.06,336.18c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-3",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M230.09,330.68c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM230.7,332.31c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "h-2",
    "data-name": "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aE-2",
    "data-name": "aE",
    className: "cls-6-Passport-p2",
    d: "M252.5,330.68c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM251.95,342.5c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF-2",
    "data-name": "aF",
    className: "cls-6-Passport-p2",
    d: "M270.42,330.95l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aK",
    className: "cls-6-Passport-p2",
    d: "M279.32,327.02c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM281.56,335.5c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL",
    className: "cls-6-Passport-p2",
    d: "M303.08,326.81c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM303.08,342.23c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM",
    className: "cls-6-Passport-p2",
    d: "M326.98,331.7c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "rect8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3-Passport-p2",
    d: "M.5,629.26c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "e-3",
    "data-name": "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aq-3",
    "data-name": "aq",
    className: "cls-6-Passport-p2",
    d: "M35.21,653.63v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-5",
    "data-name": "ar",
    className: "cls-6-Passport-p2",
    d: "M48.32,657.5c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-7",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M58.23,666.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM51.92,664.97c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-5",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M70.18,655.4c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-4",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M84.98,658.86c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-4",
    "data-name": "av",
    className: "cls-6-Passport-p2",
    d: "M89.67,668.57v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-8",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M102.98,666.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM96.66,664.97c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-6",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M110.99,665.38c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-5",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M115.4,652.88v-2.04h2.17v2.04h-2.17ZM115.4,668.57v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-4",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M125.93,655.4c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM125.86,667.21c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-6",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M140.66,655.4c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-3",
    "data-name": "aB",
    className: "cls-6-Passport-p2",
    d: "M160.9,655.4c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM160.35,667.21c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-9",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M176.24,666.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM169.93,664.97c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-5",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M189.42,658.86c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-6",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M201.64,658.86c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-8",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M211.48,655.4c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM215.02,660.9c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-4",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M224.05,655.4c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM224.66,657.03c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aE-3",
    "data-name": "aE",
    className: "cls-6-Passport-p2",
    d: "M246.45,655.4c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM245.91,667.21c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-10",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M261.8,666.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM255.48,664.97c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN",
    className: "cls-6-Passport-p2",
    d: "M272.32,657.09c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO",
    className: "cls-6-Passport-p2",
    d: "M287.74,668.57l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-7",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M301.05,665.38c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-5",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M310.62,655.4c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM310.55,667.21c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aG-2",
    "data-name": "aG",
    className: "cls-6-Passport-p2",
    d: "M153.9,697.9v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH-2",
    "data-name": "aH",
    className: "cls-6-Passport-p2",
    d: "M169.32,689.01c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM162.73,688.26c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM162.73,696.07c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-2",
    "data-name": "aI",
    className: "cls-6-Passport-p2",
    d: "M190.5,691.59c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "rect9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3-Passport-p2",
    d: "M.5,799.87c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aG-3",
    "data-name": "aG",
    className: "cls-6-Passport-p2",
    d: "M53.55,853.49v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH-3",
    "data-name": "aH",
    className: "cls-6-Passport-p2",
    d: "M68.96,844.59c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM62.37,843.85c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM62.37,851.65c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-3",
    "data-name": "aI",
    className: "cls-6-Passport-p2",
    d: "M90.15,847.17c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-4",
    "data-name": "aB",
    className: "cls-6-Passport-p2",
    d: "M106.58,840.31c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM106.03,852.13c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-6",
    "data-name": "ar",
    className: "cls-6-Passport-p2",
    d: "M120.09,842.42c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-6",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M127.22,840.31c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM127.15,852.13c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-3",
    "data-name": "aC",
    className: "cls-6-Passport-p2",
    d: "M141.34,853.49h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-6",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M147.86,837.8v-2.04h2.17v2.04h-2.17ZM147.86,853.49v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-5",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M157.37,840.31c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM157.98,841.94c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-9",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M171.97,840.31c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM175.5,845.81c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-7",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M187.92,843.78c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-8",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M201.77,850.3c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-10",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M211.35,840.31c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM214.88,845.81c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-8",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M227.31,843.78c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-9",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M234.37,850.3c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-5",
    "data-name": "av",
    className: "cls-6-Passport-p2",
    d: "M245.57,853.49v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-7",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M250.94,837.8v-2.04h2.17v2.04h-2.17ZM250.94,853.49v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-7",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M262.61,840.31c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO-2",
    "data-name": "aO",
    className: "cls-6-Passport-p2",
    d: "M277.96,853.49l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-9",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M289.64,843.78c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "rect11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3-Passport-p2",
    d: "M.5,970.47c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aM-2",
    "data-name": "aM",
    className: "cls-6-Passport-p2",
    d: "M30.36,1011.94c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP",
    className: "cls-6-Passport-p2",
    d: "M39.25,1024.36c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-10",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M56.3,1014.38c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-10",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M63.36,1020.9c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-7",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M72.93,1010.92c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM72.86,1022.74c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-6",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M85.49,1010.92c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM86.1,1012.55c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-8",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M94.93,1008.41v-2.04h2.17v2.04h-2.17ZM94.93,1024.09v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-11",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M108.24,1021.65c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM101.93,1020.49c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-8",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M120.19,1010.92c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC-4",
    "data-name": "aC",
    className: "cls-6-Passport-p2",
    d: "M139.95,1024.09h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-12",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M154.41,1021.65c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM148.1,1020.49c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-6",
    "data-name": "av",
    className: "cls-6-Passport-p2",
    d: "M160.05,1024.09v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-9",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M165.41,1008.41v-2.04h2.17v2.04h-2.17ZM165.41,1024.09v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-7",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M174.92,1010.92c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM175.53,1012.55c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-13",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M192.3,1021.65c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM185.99,1020.49c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-11",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M200.31,1020.9c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-11",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M209.89,1010.92c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM213.42,1016.42c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-11",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M225.85,1014.38c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aN-2",
    "data-name": "aN",
    className: "cls-6-Passport-p2",
    d: "M242.21,1012.62c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ",
    className: "cls-6-Passport-p2",
    d: "M255.11,1012.62c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-14",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M271.07,1021.65c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM264.75,1020.49c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-9",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M283.02,1010.92c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR",
    className: "cls-6-Passport-p2",
    d: "M300.67,1011.19c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM295.04,1022.6c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-12",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M309.02,1010.92c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM312.56,1016.42c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-12",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M324.98,1014.38c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "rect7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3-Passport-p2",
    d: "M.5,458.66c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aS",
    className: "cls-6-Passport-p2",
    d: "M20.68,481.12c8.01-.48,14.67.54,14.46,8.28-.2,5.3-2.92,8.56-8.22,8.56h-6.25v-16.84ZM22.92,496.13c6.04.54,9.91-1.09,9.91-6.72s-4.07-6.86-9.91-6.45v13.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-8",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M43.02,484.79c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM42.95,496.6c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN-3",
    "data-name": "aN",
    className: "cls-6-Passport-p2",
    d: "M56.33,486.49c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-2",
    "data-name": "aP",
    className: "cls-6-Passport-p2",
    d: "M67.74,498.23c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-3",
    "data-name": "aA",
    className: "cls-6-Passport-p2",
    d: "M89.87,486.49c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-13",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M102.71,484.79c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM106.24,490.29c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-10",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M117.44,484.79c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-12",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M127.08,494.77c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aN-4",
    "data-name": "aN",
    className: "cls-6-Passport-p2",
    d: "M143.18,486.49c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-7",
    "data-name": "ar",
    className: "cls-6-Passport-p2",
    d: "M156.62,486.89c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-14",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M163.75,484.79c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM167.28,490.29c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-15",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M180.11,495.52c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM173.8,494.36c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-13",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M188.13,494.77c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-15",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M197.7,484.79c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM201.23,490.29c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-8",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M210.26,484.79c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM210.87,486.42c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as-16",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M234.44,495.52c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM228.12,494.36c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-11",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M246.39,484.79c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-9",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M257.79,484.79c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM258.4,486.42c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aN-5",
    "data-name": "aN",
    className: "cls-6-Passport-p2",
    d: "M278.91,486.49c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-9",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M291.4,484.79c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM291.34,496.6c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-10",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M303.97,484.79c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM304.58,486.42c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-16",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M318.56,484.79c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM322.1,490.29c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as-17",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M24.21,524.85c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM17.9,523.7c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-11",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M33.99,514.12c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM34.6,515.75c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-12",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M47.57,514.12c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM48.18,515.75c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-17",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M62.17,514.12c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM65.7,519.62c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-13",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M74.73,514.12c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM75.34,515.75c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-14",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M93.34,524.1c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-10",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M102.91,514.12c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM102.84,525.94c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-15",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M120.5,524.1c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-8",
    "data-name": "ar",
    className: "cls-6-Passport-p2",
    d: "M131.02,516.23c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-18",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M140.94,524.85c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM134.62,523.7c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-12",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M152.89,514.12c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-13",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M167.69,517.59c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-7",
    "data-name": "av",
    className: "cls-6-Passport-p2",
    d: "M172.37,527.3v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-19",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M185.68,524.85c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM179.37,523.7c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-16",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M193.69,524.1c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-10",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M198.11,511.61v-2.04h2.17v2.04h-2.17ZM198.11,527.3v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-11",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M208.63,514.12c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM208.56,525.94c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-13",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M223.37,514.12c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-17",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M239.8,524.1c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-18",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M249.37,514.12c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM252.9,519.62c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-4",
    "data-name": "aA",
    className: "cls-6-Passport-p2",
    d: "M270.42,515.82c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-5",
    "data-name": "aB",
    className: "cls-6-Passport-p2",
    d: "M284.27,514.12c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM283.73,525.94c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-8",
    "data-name": "av",
    className: "cls-6-Passport-p2",
    d: "M291.68,527.3v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-20",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M304.98,524.85c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM298.67,523.7c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-18",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M313,524.1c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-19",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M322.57,514.12c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM326.1,519.62c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "rect4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-Passport-p2",
    d: "M660.5,117.44c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "q-2",
    "data-name": "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aG-4",
    "data-name": "aG",
    className: "cls-6-Passport-p2",
    d: "M764.4,158.31v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH-4",
    "data-name": "aH",
    className: "cls-6-Passport-p2",
    d: "M779.82,149.42c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM773.23,148.67c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM773.23,156.48c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-4",
    "data-name": "aI",
    className: "cls-6-Passport-p2",
    d: "M801,152c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-6",
    "data-name": "aB",
    className: "cls-6-Passport-p2",
    d: "M817.44,145.14c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM816.89,156.95c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-9",
    "data-name": "ar",
    className: "cls-6-Passport-p2",
    d: "M830.95,147.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-12",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M838.08,145.14c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM838.01,156.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-5",
    "data-name": "aC",
    className: "cls-6-Passport-p2",
    d: "M852.2,158.31h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-11",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M858.72,142.63v-2.04h2.17v2.04h-2.17ZM858.72,158.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-14",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M868.23,145.14c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM868.84,146.77c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-20",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M882.82,145.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM886.35,150.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-14",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M898.78,148.6c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au-15",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M779.44,177.94c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-19",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M786.51,184.45c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-21",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M798.86,185.2c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM792.55,184.05c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-2",
    "data-name": "aR",
    className: "cls-6-Passport-p2",
    d: "M814.89,174.74c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM809.25,186.15c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-12",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M818.08,171.96v-2.04h2.17v2.04h-2.17ZM818.08,187.65v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-14",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M829.76,174.47c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-3",
    "data-name": "aR",
    className: "cls-6-Passport-p2",
    d: "M847.41,174.74c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM841.78,186.15c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au-16",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M864.93,177.94c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-13",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M869.62,171.96v-2.04h2.17v2.04h-2.17ZM869.62,187.65v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-20",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M877.36,184.45c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-21",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M886.93,174.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM890.46,179.97c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "rect6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-Passport-p2",
    d: "M660.5,288.05c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "u-2",
    "data-name": "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aM-3",
    "data-name": "aM",
    className: "cls-6-Passport-p2",
    d: "M705.6,329.51c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-3",
    "data-name": "aP",
    className: "cls-6-Passport-p2",
    d: "M714.5,341.94c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-17",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M731.54,331.96c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-21",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M738.6,338.48c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-13",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M748.18,328.5c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM748.11,340.31c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-15",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M760.74,328.5c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM761.35,330.13c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-14",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M770.18,325.98v-2.04h2.17v2.04h-2.17ZM770.18,341.67v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-22",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M783.48,339.22c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM777.17,338.07c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-15",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M795.44,328.5c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aN-6",
    "data-name": "aN",
    className: "cls-6-Passport-p2",
    d: "M814.38,330.19c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-14",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M826.87,328.5c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM826.81,340.31c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-5",
    "data-name": "aA",
    className: "cls-6-Passport-p2",
    d: "M847.92,330.19c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-7",
    "data-name": "aB",
    className: "cls-6-Passport-p2",
    d: "M861.77,328.5c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM861.23,340.31c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-9",
    "data-name": "av",
    className: "cls-6-Passport-p2",
    d: "M869.18,341.67v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-22",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M879.7,328.5c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM883.23,334c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-22",
    "data-name": "aw",
    className: "cls-6-Passport-p2",
    d: "M890.5,338.48c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-23",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M900.07,328.5c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM903.6,334c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-18",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M916.03,331.96c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI-5",
    "data-name": "aI",
    className: "cls-6-Passport-p2",
    d: "M941.63,335.35c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT",
    className: "cls-6-Passport-p2",
    d: "M957.38,341.67l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31ZM954.8,334.95l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-4",
    "data-name": "aq",
    className: "cls-6-Passport-p2",
    d: "M966.55,326.73v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "rect10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-Passport-p2",
    d: "M660.5,799.87c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aM-4",
    "data-name": "aM",
    className: "cls-6-Passport-p2",
    d: "M764.47,841.33c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-15",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M774.45,840.31c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM774.39,852.13c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-16",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M789.19,840.31c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU",
    className: "cls-6-Passport-p2",
    d: "M801.68,837.6c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-15",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M803.24,837.8v-2.04h2.17v2.04h-2.17ZM803.24,853.49v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-10",
    "data-name": "ar",
    className: "cls-6-Passport-p2",
    d: "M814.72,842.42c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-6",
    "data-name": "aA",
    className: "cls-6-Passport-p2",
    d: "M829.32,842.01c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aR-4",
    "data-name": "aR",
    className: "cls-6-Passport-p2",
    d: "M854.17,840.59c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM848.53,851.99c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-16",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M862.52,840.31c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM862.45,852.13c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV",
    className: "cls-6-Passport-p2",
    d: "M870.4,847.92v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-10",
    "data-name": "av",
    className: "cls-6-Passport-p2",
    d: "M879.02,853.49v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-16",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M884.39,837.8v-2.04h2.17v2.04h-2.17ZM884.39,853.49v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-6",
    "data-name": "aC",
    className: "cls-6-Passport-p2",
    d: "M895.45,853.49h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-24",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M907.13,840.31c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM910.66,845.81c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "rect12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-Passport-p2",
    d: "M660.5,970.47c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aW",
    className: "cls-6-Passport-p2",
    d: "M732.52,1012.07c-.07,2.78-1.56,4.35-4.07,4.75l4.75,7.27h-2.58l-4.41-6.99h-5.23v6.99h-2.24v-16.84c5.98.2,13.92-1.43,13.78,4.82ZM720.98,1015.33c4.07-.14,9.3.88,9.3-3.19s-5.43-2.85-9.3-3.06v6.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-25",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M741.08,1010.92c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM744.61,1016.42c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN-7",
    "data-name": "aN",
    className: "cls-6-Passport-p2",
    d: "M754.39,1012.62c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-17",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M766.88,1010.92c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM766.81,1022.74c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-11",
    "data-name": "ar",
    className: "cls-6-Passport-p2",
    d: "M781.41,1013.03c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-16",
    "data-name": "aD",
    className: "cls-6-Passport-p2",
    d: "M787.52,1010.92c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM788.14,1012.55c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ax-17",
    "data-name": "ax",
    className: "cls-6-Passport-p2",
    d: "M803.75,1008.41v-2.04h2.17v2.04h-2.17ZM803.75,1024.09v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-17",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M815.43,1010.92c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aN-8",
    "data-name": "aN",
    className: "cls-6-Passport-p2",
    d: "M834.38,1012.62c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-2",
    "data-name": "aQ",
    className: "cls-6-Passport-p2",
    d: "M847.28,1012.62c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-23",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M863.23,1021.65c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM856.92,1020.49c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-18",
    "data-name": "at",
    className: "cls-6-Passport-p2",
    d: "M875.19,1010.92c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-5",
    "data-name": "aR",
    className: "cls-6-Passport-p2",
    d: "M892.84,1011.19c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM887.2,1022.6c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-26",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M901.19,1010.92c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM904.72,1016.42c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-11",
    "data-name": "av",
    className: "cls-6-Passport-p2",
    d: "M916.4,1024.09v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-18",
    "data-name": "ay",
    className: "cls-6-Passport-p2",
    d: "M926.93,1010.92c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM926.86,1022.74c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-6",
    "data-name": "aR",
    className: "cls-6-Passport-p2",
    d: "M945.73,1011.19c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM940.1,1022.6c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "diamond1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11-Passport-p2",
    d: "M826.48,481.12c3.17-1.9,7.13-1.9,10.3,0l160.82,96.6c1.71,1.02,2.26,3.23,1.24,4.94-.31.51-.73.94-1.24,1.24l-160.83,96.63c-3.17,1.9-7.13,1.9-10.3,0l-160.82-96.61c-1.71-1.02-2.26-3.23-1.24-4.94.31-.51.73-.94,1.24-1.24l160.83-96.62Z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aX",
    className: "cls-2-Passport-p2",
    d: "M764.01,534.11c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY",
    className: "cls-2-Passport-p2",
    d: "M774.4,534.79c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ",
    className: "cls-2-Passport-p2",
    d: "M790.36,543.82c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM784.04,542.67c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba",
    className: "cls-2-Passport-p2",
    d: "M802.31,533.09c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb",
    className: "cls-2-Passport-p2",
    d: "M819.96,533.37c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM814.33,544.77c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc",
    className: "cls-2-Passport-p2",
    d: "M828.31,533.09c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM831.84,538.59c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd",
    className: "cls-2-Passport-p2",
    d: "M844.27,536.56c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aZ-2",
    "data-name": "aZ",
    className: "cls-2-Passport-p2",
    d: "M863.69,543.82c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM857.38,542.67c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be",
    className: "cls-2-Passport-p2",
    d: "M874.55,530.38c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be-2",
    "data-name": "be",
    className: "cls-2-Passport-p2",
    d: "M880.87,530.38c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-2",
    "data-name": "bc",
    className: "cls-2-Passport-p2",
    d: "M887.59,533.09c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM891.12,538.59c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf",
    className: "cls-2-Passport-p2",
    d: "M900.9,534.79c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg",
    className: "cls-2-Passport-p2",
    d: "M910.61,543.08c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bf-2",
    "data-name": "bf",
    className: "cls-2-Passport-p2",
    d: "M745.78,575.86c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh",
    className: "cls-2-Passport-p2",
    d: "M757.19,587.61c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi",
    className: "cls-2-Passport-p2",
    d: "M772.8,576.27c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi-2",
    "data-name": "bi",
    className: "cls-2-Passport-p2",
    d: "M780.88,576.27c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-3",
    "data-name": "bc",
    className: "cls-2-Passport-p2",
    d: "M788.01,574.16c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM791.55,579.66c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-2",
    "data-name": "ba",
    className: "cls-2-Passport-p2",
    d: "M802.75,574.16c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-2",
    "data-name": "bg",
    className: "cls-2-Passport-p2",
    d: "M812.39,584.14c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aZ-3",
    "data-name": "aZ",
    className: "cls-2-Passport-p2",
    d: "M831.54,584.89c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM825.22,583.74c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj",
    className: "cls-2-Passport-p2",
    d: "M843.35,574.16c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM842.81,585.98c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-2",
    "data-name": "bj",
    className: "cls-2-Passport-p2",
    d: "M856.93,574.16c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM856.39,585.98c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi-3",
    "data-name": "bi",
    className: "cls-2-Passport-p2",
    d: "M870.45,576.27c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bk",
    className: "cls-2-Passport-p2",
    d: "M877.58,574.16c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM877.51,585.98c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl",
    className: "cls-2-Passport-p2",
    d: "M891.7,587.33h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-4",
    "data-name": "bc",
    className: "cls-2-Passport-p2",
    d: "M903.38,574.16c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM906.91,579.66c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm",
    className: "cls-2-Passport-p2",
    d: "M915.94,574.16c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM916.55,575.79c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bm-2",
    "data-name": "bm",
    className: "cls-2-Passport-p2",
    d: "M777.38,615.23c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM777.99,616.86c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bk-2",
    "data-name": "bk",
    className: "cls-2-Passport-p2",
    d: "M791.98,615.23c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM791.91,627.04c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-3",
    "data-name": "bf",
    className: "cls-2-Passport-p2",
    d: "M805.29,616.93c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh-2",
    "data-name": "bh",
    className: "cls-2-Passport-p2",
    d: "M816.69,628.67c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bn",
    className: "cls-2-Passport-p2",
    d: "M838.83,616.93c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-5",
    "data-name": "bc",
    className: "cls-2-Passport-p2",
    d: "M851.66,615.23c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM855.19,620.73c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-3",
    "data-name": "ba",
    className: "cls-2-Passport-p2",
    d: "M866.4,615.23c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-3",
    "data-name": "bg",
    className: "cls-2-Passport-p2",
    d: "M876.04,625.21c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo",
    className: "cls-2-Passport-p2",
    d: "M885.82,611.36c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89ZM884.05,628.4v-2.38h2.31v2.38h-2.31"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-14-Passport-p2",
    d: "M171.63,224.44v40.73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M172.13,224.46h-1v-.52h1v.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-Passport-p2",
    d: "M171.63,279.92l-4.64-14.25h9.26l-4.62,14.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14-Passport-p2",
    d: "M171.63,395.05v40.72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M172.13,395.06h-1v-.5h1v.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-Passport-p2",
    d: "M171.63,450.54l-4.64-14.27h9.26l-4.62,14.27Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14-Passport-p2",
    d: "M171.63,565.66v40.72"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M172.13,565.67h-1v-.5h1v.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-Passport-p2",
    d: "M171.63,621.15l-4.64-14.27h9.26l-4.62,14.27Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14-Passport-p2",
    d: "M171.63,736.26v40.73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M172.13,736.28h-1v-.52h1v.52Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-Passport-p2",
    d: "M171.63,791.75l-4.64-14.27h9.26l-4.62,14.27Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14-Passport-p2",
    d: "M171.63,906.87v40.72"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M172.13,906.88h-1v-.5h1v.5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-Passport-p2",
    d: "M171.63,962.36l-4.64-14.27h9.26l-4.62,14.27Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14-Passport-p2",
    d: "M831.63,224.44v40.73"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M832.13,224.46h-1v-.52h1v.52Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-Passport-p2",
    d: "M831.63,279.92l-4.64-14.25h9.26l-4.62,14.25Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14-Passport-p2",
    d: "M831.63,395.05v67.75"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M832.13,395.06h-1v-.5h1v.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-Passport-p2",
    d: "M831.63,477.57l-4.64-14.27h9.26l-4.62,14.27Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M832.13,776.99h-1v-34.37h1v34.37ZM832.13,713.29h-1v-30.3h1v30.3Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-Passport-p2",
    d: "M831.63,682.48l.5-.03v.54h-1v-.54l.5.03Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M831.63,682.46l.52-.03v.6h-1.05v-.6l.53.03ZM831.15,682.96h.95v-.48l-.47.02-.48-.02v.48Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-Passport-p2",
    d: "M831.63,791.75l-4.64-14.27h9.26l-4.62,14.27Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M831.63,793.37l-5.33-16.38h10.65l-5.32,16.38ZM827.68,777.99l3.95,12.13,3.94-12.13h-7.89Z"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bp",
    className: "cls-9-Passport-p2",
    d: "M826.23,732.85l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq",
    className: "cls-9-Passport-p2",
    d: "M840.42,715.8c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM840.42,731.22c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14-Passport-p2",
    d: "M831.63,906.87v40.72"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M832.13,906.88h-1v-.5h1v.5Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-Passport-p2",
    d: "M831.63,962.36l-4.64-14.27h9.26l-4.62,14.27Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14-Passport-p2",
    d: "M343.75,1020.47h56.46"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M343.76,1020.97h-.5v-1h.5v1Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13-Passport-p2",
    d: "M414.97,1020.47l-14.27,4.65v-9.28l14.27,4.63Z"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "rect13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-Passport-p2",
    d: "M416.6,985.69c0-3.31,2.69-6,6-6h173.62c3.31,0,6,2.69,6,6v69.57c0,3.31-2.69,6-6,6h-173.62c-3.31,0-6-2.69-6-6v-69.57Z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "br",
    className: "cls-6-Passport-p2",
    d: "M452.21,1012.91c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-27",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M462.74,1012.57c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM466.27,1018.07c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-28",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M476.32,1012.57c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM479.85,1018.07c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aK-2",
    "data-name": "aK",
    className: "cls-6-Passport-p2",
    d: "M491.94,1008.9c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM494.18,1017.39c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-3",
    "data-name": "aQ",
    className: "cls-6-Passport-p2",
    d: "M513.39,1014.27c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-24",
    "data-name": "as",
    className: "cls-6-Passport-p2",
    d: "M529.35,1023.3c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM523.03,1022.14c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-19",
    "data-name": "au",
    className: "cls-6-Passport-p2",
    d: "M542.52,1016.03c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-29",
    "data-name": "az",
    className: "cls-6-Passport-p2",
    d: "M552.37,1012.57c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM555.9,1018.07c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bs",
    className: "cls-6-Passport-p2",
    d: "M574.5,1017.12c2.24.41,3.94,1.36,3.94,4.01,0,5.98-9.44,6.25-11.14,1.97-.2-.54-.34-1.09-.41-1.7l2.17-.2c.41,1.83,1.43,2.99,3.67,2.99s3.53-1.02,3.53-3.12c0-2.58-2.44-3.12-5.36-2.92v-1.9c2.65.07,4.89-.27,4.89-2.85,0-1.83-1.15-2.92-3.12-2.92s-3.19,1.02-3.33,2.78l-2.17-.2c.41-2.85,2.38-4.28,5.5-4.35,3.26-.07,5.36,1.43,5.36,4.41,0,2.44-1.43,3.53-3.53,4.01"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M590.52,581.32h-75.1l-.87.08-.84.2-.8.33-.72.46-.66.56-.56.66-.45.74-.32.8-.2.83-.07.88v376.45h-1v-376.5l.1-.98.23-1,.4-.94.52-.87.66-.78.8-.67.86-.53.94-.4,1-.23,1-.1h75.06l.02,1.01ZM662.89,581.32h-23.5v-1h23.5v1Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-Passport-p2",
    d: "M663.4,580.82l.04.5h-.56v-1h.56l-.04.5Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M663.42,580.82l.05.54h-.62v-1.05h.62l-.05.51ZM662.9,580.36v.95h.52l-.05-.5.05-.46h-.52Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7-Passport-p2",
    d: "M509.4,978.07l-4.6-14.27h9.27l-4.67,14.27Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-Passport-p2",
    d: "M509.4,979.69l-5.3-16.4h10.63l-5.33,16.4ZM505.46,964.29l3.95,12.16,3.96-12.15h-7.91Z"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bt",
    className: "cls-10-Passport-p2",
    d: "M599.83,578.73v6.99h-2.31v-6.99l-6.45-9.85h2.51l5.09,8.01,5.09-8.01h2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu",
    className: "cls-10-Passport-p2",
    d: "M608.86,585.72v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bv",
    className: "cls-10-Passport-p2",
    d: "M635.68,572.89c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportPhase2);
export default __webpack_public_path__ + "static/media/Passport_Phase_2.377c7af5b394564ad0663bf873d4e6de.svg";
export { ForwardRef as ReactComponent };